import Vue from 'vue';
import billProductTransformer from './../../transformers/creditNoteProduct';
import all from './all';

const success = (data, id, resolve) => {
  all(id);
  resolve();
};

const failed = (errors, reject) => {
  reject(billProductTransformer.fetch(errors));
};

export default (id, billProduct) => (
  new Promise((resolve, reject) => {
    Vue.$http
    .post(`/bills/${id}/products`, billProductTransformer.send(billProduct))
    .then((response) => {
      success(response.data, id, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/billProduct/store.js